const LOCAL_NAME = 'classroomStorage'

export function defaultState(): Classroom.ClassroomState {
  return {
    classrooms: [],
    loading: false,
    currentClassroom: null,
    editorTemp: null,
    pagination: {
      page: 1,
      pageSize: 10,
      itemCount: 0,
      pageCount: 0,
      pageSizes: [],
    },
    editorAgent: null,
    isFromAgent: false,
    sourceAgent: {
      sourceScreen: 'TEACHER_BOARD',
      sourceData: {},
    },
  }
}

export function getLocalState(): Classroom.ClassroomState {
  const localSetting: Classroom.ClassroomState | undefined = JSON.parse(localStorage.getItem(LOCAL_NAME) || '{}')
  return { ...defaultState(), ...localSetting }
}

export function setLocalState(classroomState: Classroom.ClassroomState): void {
  localStorage.setItem(LOCAL_NAME, JSON.stringify(classroomState))
}
